import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheck, FaTimes, FaCrown, FaMedal, FaGem, FaStar, FaRupeeSign } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';


function Plansforuser() {
  const [plansData, setPlansData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredPlan, setHoveredPlan] = useState(null);
  const [showDeactivationMessage, setShowDeactivationMessage] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [lockedModules, setLockedModules] = useState({});
  const navigate = useNavigate();
  const [activeOffer, setActiveOffer] = useState(null);  
  const [isLoading, setIsLoading] = useState(false);  

  const projectId = process.env.REACT_APP_FS_PROJECT_ID;

   const location = useLocation();
  const { state } = location;
  
  const udise = state?.udiseNumber;


  // Helper function to get plan colors
  function getPlanColor(plan, lighten = false) {
    const colors = {
      "Silver": lighten ? '#bdc3c7' : '#95a5a6',
      "Gold": lighten ? '#f1c40f' : '#f39c12',
      "Platinum": lighten ? '#B22234' : '#2980b9',
      "Platinum Plus": lighten ? '#e74c3c' : '#c0392b'
    };
    return colors[plan] || '#B22234';
  }

  // All possible features to compare against
  const allFeatures = [
    "Home", "Student Management", "Attendance", 
    "Inventory", "Time Table", "MDM", "Result",
    "Fee Management", "Account", "Payroll",
    "Student App", "Teacher App", "WhatsApp API Integration", "Unlimited Access to all features"
  ];

const fetchActiveOffers = async () => {
  try {
    const response = await fetch(`https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/offersForAll`);
    
    if (!response.ok) throw new Error('Failed to fetch offers');
    
    const offersData = await response.json();
    const currentDate = new Date();

    // Extract offers from the response
    const activeOffers = Object.values(offersData.documents).map(doc => {
      const fields = doc.fields;
      return {
        id: doc.name.split('/').pop(), // Extract the document ID
        title: fields.title.stringValue,
        description: fields.description.stringValue,
        startDate: fields.startDate.stringValue,
        endDate: fields.endDate.stringValue,
        minAmount: fields.minAmount.integerValue,
        percentage: fields.percentage.doubleValue ||  fields.percentage.integerValue ,
        status: fields.status.stringValue
      };
    }).filter(offer => {
      const startDate = new Date(offer.startDate);
      const endDate = new Date(offer.endDate);
      return offer.status === 'active' && currentDate >= startDate && currentDate <= endDate;
    });

    console.log("activeOffers", activeOffers);
    
    if (activeOffers.length > 0) {
      setActiveOffer(activeOffers[0]); // Set the first active offer
    }
  } catch (error) {
    console.error('Error fetching active offers:', error);
  }
};


  //fetch active
  useEffect(() => {
    fetchActiveOffers(); // Fetch active offers on component mount
  }, []);

  const getAgentAndUdise = async (udise) => {
  const res = await fetch(`https://digischoolweb-default-rtdb.firebaseio.com/Admin/${udise}.json`);
  if (!res.ok) throw new Error('Failed to fetch data');
  const data = await res.json();
  return {
    agentId: data.agentId,
  };
};

const saveToFirestore = async (agentId, udise, newData) => {
  const url = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/sells/${agentId}/schools/${udise}`;

  try {
    // 1. First fetch the existing document
    const existingResponse = await fetch(url);
    if (!existingResponse.ok) {
      throw new Error(`Failed to fetch existing document: ${await existingResponse.text()}`);
    }
    const existingDoc = await existingResponse.json();
    
    // 2. Create a copy of existing fields in Firestore format
    const existingFields = existingDoc.fields || {};
    
    // 3. Convert new data to Firestore format
    const newFields = {};
    Object.entries(newData).forEach(([key, value]) => {
      if (typeof value === 'string') {
        newFields[key] = { stringValue: value };
      } else if (typeof value === 'number') {
        newFields[key] = { integerValue: value.toString() };
      } else if (typeof value === 'boolean') {
        newFields[key] = { booleanValue: value };
      } else if (value && typeof value === 'object') {
        // Handle objects (like lockedModules)
        const mapFields = {};
        Object.entries(value).forEach(([mapKey, mapValue]) => {
          mapFields[mapKey] = { stringValue: mapValue };
        });
        newFields[key] = { mapValue: { fields: mapFields } };
      }
    });

    // 4. Merge the fields - preserve existing, add/update new
    const mergedFields = {
      ...existingFields,
      ...newFields
    };

    const firestoreBody = {
      fields: mergedFields
    };

    // 5. Send the update
    const res = await fetch(url, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(firestoreBody)
    });

    if (!res.ok) {
      throw new Error(`Firestore error: ${await res.text()}`);
    }

    return await res.json();
  } catch (error) {
    console.error('Error saving to Firestore:', error);
    throw error;
  }
};




  // Default plan features configuration for our specific plans
  const defaultPlanFeatures = {
    "Silver": {
      studentLimit: "Up to 100 students",
      icon: <FaMedal className="text-secondary" />,
      features: [
        "Home", "Student Management", "Attendance", 
        "Inventory", "Time Table"
      ],
      lockedModules: {
        Account: "locked",
        Fee: "locked",
        MDM: "locked",
        Result: "locked",
        Payroll: "locked"
      }
    },
    "Gold": {
      studentLimit: "Up to 500 students",
      icon: <FaGem className="text-warning" />,
      features: [
        "Home", "Student Management", "Attendance", 
        "Inventory", "Time Table", "MDM", "Result"
      ],
      lockedModules: {
        Account: "locked",
        Fee: "locked",
        Payroll: "locked"
      }
    },
    "Platinum": {
      studentLimit: "Up to 1000 students",
      icon: <FaStar className="text-info" />,
      features: [
        "Home", "Student Management", "Attendance", 
        "Inventory", "Time Table", "MDM", "Result",
        "Fee Management", "Account", "Payroll",
        "Student App", "Teacher App"
      ],
      lockedModules: {} // All modules unlocked
    },
    "Platinum Plus": {
      studentLimit: "1000+ students (Unlimited)",
      icon: <FaCrown className="text-black" />,
      features: [
        "Home", "Student Management", "Attendance", 
        "Inventory", "Time Table", "MDM", "Result",
        "Fee Management", "Account", "Payroll", "Student App", "Teacher App", "WhatsApp API Integration", "Unlimited Access to all features"
      ],
      lockedModules: {} // All modules unlocked
    } 
  };

  // The specific plans we want to show
  const plansToShow = ["Silver", "Gold", "Platinum", "Platinum Plus"];

  useEffect(() => {
    const fetchPlans = async () => {
      try {

        if (udise) {
          const userResponse = await fetch(
            `https://digischoolweb-default-rtdb.firebaseio.com/Admin/${udise}/purchesPlan.json`
          );
          const userData = await userResponse.json();
          
          if (userData) {
            setShowDeactivationMessage(true);

            // Filter to only include our specific plans
            const filteredPlans = {};
            plansToShow.forEach(plan => {
              if (userData[plan]) {
                filteredPlans[plan] = userData[plan];
              }
            });
            
            if (Object.keys(filteredPlans).length > 0) {
              setPlansData(filteredPlans);
              setLoading(false);
              return;
            }
          }
        }

        // If no user-specific plans, fetch from general Admin/purchesPlan
        const adminResponse = await fetch(
          'https://digischoolweb-default-rtdb.firebaseio.com/Admin/purchesPlan.json'
        );
        const adminData = await adminResponse.json();
        
        // Filter to only include our specific plans
        const filteredPlans = {};
        if (adminData) {
          plansToShow.forEach(plan => {
            if (adminData[plan]) {
              filteredPlans[plan] = adminData[plan];
            }
          });
        }

        // If we got any plans from the database, use them
        if (Object.keys(filteredPlans).length > 0) {
          setPlansData(filteredPlans);
        } else {
          // Otherwise use our default data for these specific plans
          setPlansData({
            "Silver": { mrp: "3500", fixRate: "1000", earlyRenewal: "1000" },
            "Gold": { mrp: "15000", fixRate: "2000", earlyRenewal: "2000" },
            "Platinum": { mrp: "40000", fixRate: "3000", earlyRenewal: "3000" },
            "Platinum Plus": { mrp: "80000", fixRate: "2500", earlyRenewal: "2500" }
          });
        }
        
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const toggleMessageSize = () => {
    setShowDeactivationMessage(false);
  };






const saveLockedModulesToRealtimeDB = async (udise, lockedModules) => {
  const url = `https://digischoolweb-default-rtdb.firebaseio.com/Admin/${udise}/lockedModules.json`;

  try {
    const res = await fetch(url, {
      method: "PUT", // Using PUT to overwrite completely
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(lockedModules),
    });

    if (!res.ok) {
      throw new Error(`Realtime Database error: ${await res.text()}`);
    }
    return await res.json();
  } catch (error) {
    console.error('Error saving to Realtime DB:', error);
    throw error;
  }
};

const handlePackageSelection = (plan) => {
  setSelectedPackage(plan);
  setLockedModules(defaultPlanFeatures[plan].lockedModules);
};


// Add this function to your existing code
const distributeCommissionToParents = async (currentAgentId, totalAmount) => {
  try {
    const superAdminId = "7020181674"; // Replace with your actual super admin ID
    let currentAgent = currentAgentId;
    const commissionDistribution = [];

    // Store last child's percentage to subtract from parent
    let lastAgentPercentage = 0;

    while (currentAgent && currentAgent !== superAdminId) {
      // Fetch current agent data
      const agentUrl = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/agents/${currentAgent}`;
      const agentResponse = await fetch(agentUrl);

      if (!agentResponse.ok) {
        console.error(`Failed to fetch agent ${currentAgent}`);
        break;
      }

      const agentData = await agentResponse.json();
      const currentAgentPercentage = parseInt(agentData.fields.dealershipPercentage?.stringValue || "0", 10);
      const parentId = agentData.fields.parentId?.stringValue;

      if (!parentId || parentId === superAdminId) {
        break;
      }

      // Fetch parent agent data
      const parentUrl = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/agents/${parentId}`;
      const parentResponse = await fetch(parentUrl);

      if (!parentResponse.ok) {
        console.error(`Failed to fetch parent agent ${parentId}`);
        break;
      }

      const parentData = await parentResponse.json();
      let parentPercentage = parseInt(parentData.fields.dealershipPercentage?.stringValue || "0", 10);

      // Adjust parent percentage by subtracting child's percentage
      parentPercentage = parentPercentage - currentAgentPercentage;
      if (parentPercentage < 0) parentPercentage = 0;

      if (parentPercentage > 0) {
        const commissionAmount = Math.floor(totalAmount * (parentPercentage / 100));

        commissionDistribution.push({
          agentId: parentId,
          percentage: parentPercentage,
          amount: commissionAmount,
          agentName: parentData.fields.name?.stringValue || 'Unknown'
        });

        // Update wallet
        await updateAgentWalletPoints(parentId, commissionAmount);
      }

      // Move up
      lastAgentPercentage = currentAgentPercentage;
      currentAgent = parentId;
    }

    console.log('Commission distribution completed:', commissionDistribution);
    return commissionDistribution;

  } catch (error) {
    console.error('Error in distributeCommissionToParents:', error);
    throw error;
  }
};

//check this code this code gets the superadmin id from the firebase check if working correct the keep this 
// const distributeCommissionToParents = async (currentAgentId, totalAmount) => {
//   try {
//     // Fetch superAdminId from Firestore
//     const superAdminUrl = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/superadmin/superadmin`;
//     const superAdminResponse = await fetch(superAdminUrl);

//     if (!superAdminResponse.ok) {
//       throw new Error(`Failed to fetch superadmin: ${await superAdminResponse.text()}`);
//     }

//     const superAdminData = await superAdminResponse.json();
//     const superAdminId = superAdminData.fields.id?.stringValue || superAdminData.fields.id?.integerValue;

//     let currentAgent = currentAgentId;
//     const commissionDistribution = [];

//     while (currentAgent && currentAgent !== superAdminId) {
//       // Fetch current agent data
//       const agentUrl = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/agents/${currentAgent}`;
//       const agentResponse = await fetch(agentUrl);

//       if (!agentResponse.ok) {
//         console.error(`Failed to fetch agent ${currentAgent}`);
//         break;
//       }

//       const agentData = await agentResponse.json();
//       const currentAgentPercentage = parseInt(agentData.fields.dealershipPercentage?.stringValue || "0", 10);
//       const parentId = agentData.fields.parentId?.stringValue;

//       if (!parentId || parentId === superAdminId) {
//         break;
//       }

//       // Fetch parent agent data
//       const parentUrl = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/agents/${parentId}`;
//       const parentResponse = await fetch(parentUrl);

//       if (!parentResponse.ok) {
//         console.error(`Failed to fetch parent agent ${parentId}`);
//         break;
//       }

//       const parentData = await parentResponse.json();
//       let parentPercentage = parseInt(parentData.fields.dealershipPercentage?.stringValue || "0", 10);

//       // Adjust parent percentage by subtracting child's percentage
//       parentPercentage = parentPercentage - currentAgentPercentage;
//       if (parentPercentage < 0) parentPercentage = 0;

//       if (parentPercentage > 0) {
//         const commissionAmount = Math.floor(totalAmount * (parentPercentage / 100));

//         commissionDistribution.push({
//           agentId: parentId,
//           percentage: parentPercentage,
//           amount: commissionAmount,
//           agentName: parentData.fields.name?.stringValue || 'Unknown'
//         });

//         // Update wallet
//         await updateAgentWalletPoints(parentId, commissionAmount);
//       }

//       currentAgent = parentId;
//     }

//     console.log('Commission distribution completed:', commissionDistribution);
//     return commissionDistribution;

//   } catch (error) {
//     console.error('Error in distributeCommissionToParents:', error);
//     throw error;
//   }
// };


// Helper function to update agent wallet points



const updateAgentWalletPoints = async (agentId, commissionAmount) => {
  try {
    const walletPointsUrl = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/walletPoints/${agentId}`;
    const walletPointsResponse = await fetch(walletPointsUrl);
    
    let currentTotalWalletPoints = 0;
    let walletPointsData;
    
    if (walletPointsResponse.ok) {
      walletPointsData = await walletPointsResponse.json();
      currentTotalWalletPoints = parseInt(walletPointsData.fields.totalWalletPoints?.integerValue || "0", 10);
    } else if (walletPointsResponse.status === 404) {
      // Document not found, create it with initial values
      const initialWalletPointsData = {
        fields: {
          agentId: { stringValue: agentId },
          totalWalletPoints: { integerValue: 0 },
        }
      };
      await fetch(walletPointsUrl, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(initialWalletPointsData),
      });
    } else {
      throw new Error(`Failed to fetch wallet points for agent ${agentId}: ${await walletPointsResponse.text()}`);
    }
    
    // Calculate new wallet points
    const updatedTotalWalletPoints = currentTotalWalletPoints + commissionAmount;
    
    // Create a unique key for the month and year
    const monthYearKey = `${new Date().getMonth() + 1}_${new Date().getFullYear()}`;
    let currentMonthWalletPoints = 0;
    
    if (walletPointsData) {
      currentMonthWalletPoints = parseInt(walletPointsData.fields[monthYearKey]?.integerValue || "0", 10);
    }
    
    // Update the wallet points document
    await fetch(walletPointsUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fields: {
          totalWalletPoints: { integerValue: updatedTotalWalletPoints },
          [monthYearKey]: { integerValue: currentMonthWalletPoints + commissionAmount }
        }
      }),
    });
    
    console.log(`Updated wallet points for agent ${agentId}: +${commissionAmount}`);
    
  } catch (error) {
    console.error(`Error updating wallet points for agent ${agentId}:`, error);
    throw error;
  }
};

const handlePayment = async (plan) => {
  try {
     setIsLoading(true); 
    const selectedPlanLockedModules = defaultPlanFeatures[plan].lockedModules;
    setLockedModules(selectedPlanLockedModules);
    setSelectedPackage(plan);

    const amount = parseInt(plansData[plan]?.mrp || "0", 10);
    let appliedOffer = null;
    console.log("|activeOffer",activeOffer);
   

    if (activeOffer) {
       appliedOffer = {
        ...activeOffer, 
      };
    }


    const response = await fetch('http://localhost/VedGurukul/create_order.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount,
        plan,
        udise,
        offerId: appliedOffer ? appliedOffer.id : null
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create order');
    }

    const orderData = await response.json();
    
    const options = {
      key: 'rzp_test_BSj1LLEYKca6Cb',
      amount: orderData.amount,
      currency: orderData.currency,
      order_id: orderData.id,
      name: 'School Management System',
      description: `${plan} Plan Subscription`,
      handler: async function(response) {
        console.log('Payment success:', response);
        alert('Payment successful! Wait for few seconds, your account will be activated shortly.');

        // Prepare data to save
        const dataToSave = {
          packActivated: plan,
          finalPrize: amount,
          lockedModules: selectedPlanLockedModules,
          userStatus: 'Active',
          status: 'Completed',
          paidAmount: amount,
          activationDate: new Date().toISOString().split('T')[0],
          deactivationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
          razorpayOrderId: orderData.id,
          razorpayPaymentId: response.razorpay_payment_id
        };

        const { agentId } = await getAgentAndUdise(udise);
        if (agentId) {
          try {
            // Save to Firestore
            await saveToFirestore(agentId, udise, dataToSave);
            console.log('Successfully saved to Firestore');
            
            // Save to Realtime Database
            await Promise.all([
              fetch(`https://digischoolweb-default-rtdb.firebaseio.com/Admin/${udise}.json`, {
                method: 'PATCH',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSave),
              }),
              saveLockedModulesToRealtimeDB(udise, selectedPlanLockedModules)
            ]);
            
            if (appliedOffer) {
              const completedOfferData = {
                offerId: appliedOffer.id,
                title: appliedOffer.title,
                description: appliedOffer.description || '',
                minAmount: appliedOffer.minAmount || '',
                percentage: appliedOffer.percentage.toString(),
                paidAmount: amount,
                schoolId: udise,
                agentId: agentId,
                paymentId: response.razorpay_payment_id,
                orderId: orderData.id,
                redeemedAt: new Date().toISOString(),
                status: 'completed'
              };
              
              // Generate a unique document ID for the completed offer
              const completedOfferId = `off_${Date.now()}_${agentId}`;
              
              // Save to completedOffers collection
              await saveToCompletedOffers(completedOfferId, completedOfferData)
            }

            console.log('Successfully saved to both databases');
            // alert("Package and modules saved successfully.");

            // Fetch the percentage value for current agent
            const percentageResponse = await fetch(`https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/agents/${agentId}`);
            
            if (!percentageResponse.ok) {
              throw new Error(`Failed to fetch agent data: ${await percentageResponse.text()}`);
            }

            const percentageData = await percentageResponse.json();
            const percentageValue = parseInt(percentageData.fields.dealershipPercentage?.stringValue || "0", 10);

            // Fetch the productId from the sells document
            const productResponse = await fetch(`https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/sells/${agentId}/schools/${udise}`);
            if (!productResponse.ok) {
              throw new Error(`Failed to fetch product data: ${await productResponse.text()}`);
            }
            const productData = await productResponse.json();
            const productId = productData.fields.productId?.stringValue || '';

            // Calculate and update current agent's wallet points
            const currentAgentCommission = Math.floor(amount * (percentageValue / 100));
            await updateAgentWalletPoints(agentId, currentAgentCommission);

            // *** NEW: Distribute commission to parent agents ***
            console.log('Starting parent commission distribution...');
            const commissionDistribution = await distributeCommissionToParents(agentId, amount);
            console.log('Parent commission distribution completed:', commissionDistribution);

            // Create a new payment document in Firestore with commission details
            const paymentData = {
              fields: {
                totalPaid: { integerValue: amount },
                agentId: { stringValue: agentId },
                createdAt: { stringValue: new Date().toISOString() },
                productId: { stringValue: productId },
                udiseNumber: { stringValue: udise },
                percentageValue: { integerValue: percentageValue },
                currentAgentCommission: { integerValue: currentAgentCommission },
                parentCommissions: { 
                  stringValue: JSON.stringify(commissionDistribution)
                }
              }
            };

            // Generate a unique document ID
            const paymentDocId = `payment${Date.now()}_${agentId}`; 
            const paymentUrl = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/paymentdone/${paymentDocId}`;

            const paymentResponse = await fetch(paymentUrl, {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(paymentData),
            });

            if (!paymentResponse.ok) {
              throw new Error(`Failed to save payment data: ${await paymentResponse.text()}`);
            }
            
            console.log('Payment data saved successfully with commission details');
            setIsLoading(false);
            setLoading(false);

          } catch (error) {
            console.error('Failed to save or distribute commission:', error);
            alert(`Failed to process payment: ${error.message}`);
          }
        }
      },
      prefill: {
        name: localStorage.getItem('schoolName') || 'School Admin',
        email: `${udise}@school.com` || 'admin@school.com',
        contact: localStorage.getItem('mobile') || '9999999999'
      },
      theme: {
        color: getPlanColor(plan)
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
    
  } catch (error) {
    console.error('Payment error:', error);
    alert(`Payment failed: ${error.message}`);
  }
};

// New function to save completed offers
const saveToCompletedOffers = async (documentId, offerData) => {
  console.log("documentId", documentId);
  console.log("offerData", offerData);
  
  const url = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/completedOffers/${documentId}`;
  try {
   
    const firestoreData = {
      fields: {
        offerId: { stringValue: offerData.offerId },
        title: { stringValue: offerData.title },
        description: { stringValue: offerData.description || '' }, 
        minAmount: { stringValue: offerData.minAmount || '' }, 
        percentage: { doubleValue: parseFloat(offerData.percentage) }, // Use doubleValue for percentage
        paidAmount: { integerValue: offerData.paidAmount.toString() }, // Ensure this is correct
        schoolId: { stringValue: offerData.schoolId },
        agentId: { stringValue: offerData.agentId },
        paymentId: { stringValue: offerData.paymentId },
        orderId: { stringValue: offerData.orderId },
        redeemedAt: { stringValue: offerData.redeemedAt },
        status: { stringValue: offerData.status }
      }
    };

    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(firestoreData),
    });

    if (!response.ok) {
      throw new Error(`Failed to save completed offer: ${await response.text()}`);
    }
    console.log('Successfully saved completed offer');
    return await response.json();
  } catch (error) {
    console.error('Error saving completed offer:', error);
    throw error;
  }
};


  if (loading || isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
        <motion.div
          animate={{ 
            rotate: 360,
            scale: [1, 1.2, 1]
          }}
          transition={{ 
            duration: 1.5,
            repeat: Infinity,
            ease: "linear"
          }}
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            border: '5px solid #f3f3f3',
            borderTop: '5px solid #B22234',
            borderRight: '5px solid #B22234'
          }}
        />
      </div>
    );
  }

  if (error) {
    return (
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="alert alert-danger mx-3 my-5"
      >
        Error loading plans: {error}
      </motion.div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>

      {/* Semi-transparent overlay that will appear behind the message */}
      {showDeactivationMessage && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(5px)',
          zIndex: 999,
        }}></div>
      )}

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        style={{ 
          padding: '20px', 
          maxWidth: '1700px', 
          margin: '0 auto',
          minHeight: '100vh'
        }}
      >
        {/* Deactivation Message */}
        {showDeactivationMessage && (
          <motion.div 
            style={{ 
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: '#f8d7da',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              zIndex: 1000,
              textAlign: 'center'
            }}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <p style={{ margin: 0 }}>
              Your account is deactivated. To activate your plan, please contact our team or directly purchase a plan according to your needs.
            </p>
            <button 
              onClick={toggleMessageSize} 
              style={{ 
                marginTop: '10px', 
                padding: '5px 10px', 
                borderRadius: '5px', 
                background: '#dc3545', 
                color: 'white', 
                border: 'none', 
                cursor: 'pointer' 
              }}
            >
              Close
            </button>
          </motion.div>
        )}

        {/* Header and back button */}
        <motion.div 
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', marginTop: '50px' }}
        >
          <h2 style={{ 
            fontSize: '2rem',
            fontWeight: '700',
            color: '#143625',
            textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
          }}>
            Subscription Plans
          </h2>
          <motion.button 
            whileHover={{ scale: 1.05, boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
            whileTap={{ scale: 0.95 }}
            className="btn btn-secondary" 
            onClick={() => navigate(-1)}
            style={{
              borderRadius: '8px',
              padding: '8px 16px',
              fontWeight: '600'
            }}
          >
            Back
          </motion.button>
        </motion.div>

        {/* Plan cards */}
        <div className="row" style={{ gap: '20px 0' }}>
          <AnimatePresence>
            {plansToShow.map((plan, index) => {
              // Skip if this plan doesn't exist in our data
              if (!plansData || !plansData[plan]) return null;
              
              return (
                <motion.div 
                  key={plan}
                  className="col-md-6 col-lg-3 mb-4"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  whileHover={{ y: -5 }}
                  onMouseEnter={() => setHoveredPlan(plan)}
                  onMouseLeave={() => setHoveredPlan(null)}
                >
                  <div className="card h-100" style={{ 
                    border: 'none', 
                    borderRadius: '12px', 
                    boxShadow: hoveredPlan === plan ? 
                      `0 15px 30px -5px ${getPlanColor(plan, true)}40` : 
                      '0 4px 20px rgba(0,0,0,0.08)',
                    transition: 'all 0.3s ease',
                    transform: hoveredPlan === plan ? 'scale(1.02)' : 'scale(1)',
                    overflow: 'hidden'
                  }}>
                    {/* Card Header */}
                    <motion.div 
                      className="card-header" 
                      style={{ 
                        background: `linear-gradient(135deg, ${getPlanColor(plan)} 0%, ${getPlanColor(plan, true)} 100%)`,
                        color: 'white',
                        borderTopLeftRadius: '12px',
                        borderTopRightRadius: '12px',
                        padding: '20px',
                        textAlign: 'center',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                    >
                      <motion.div 
                        animate={hoveredPlan === plan ? { scale: 1.1 } : { scale: 1 }}
                        transition={{ duration: 0.3 }}
                        style={{ 
                          position: 'absolute',
                          top: '-50px',
                          right: '-50px',
                          width: '100px',
                          height: '100px',
                          borderRadius: '50%',
                          background: 'rgba(255,255,255,0.1)'
                        }}
                      />
                      <motion.div 
                        animate={hoveredPlan === plan ? { scale: 1.1 } : { scale: 1 }}
                        transition={{ duration: 0.3 }}
                        style={{ 
                          position: 'absolute',
                          bottom: '-30px',
                          left: '-30px',
                          width: '60px',
                          height: '60px',
                          borderRadius: '50%',
                          background: 'rgba(255,255,255,0.1)'
                        }}
                      />
                      <div style={{ 
                        fontSize: '2rem', 
                        marginBottom: '10px',
                        position: 'relative',
                        zIndex: 1
                      }}>
                        {defaultPlanFeatures[plan]?.icon || <FaStar />}
                      </div>
                      <h4 style={{ 
                        margin: 0,
                        position: 'relative',
                        zIndex: 1,
                        textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
                      }}>
                        {plan} Plan
                      </h4>
                    </motion.div>

                    {/* Card Body */}
                    <div className="card-body" style={{ padding: '25px' }}>
                      {/* Pricing */}
                      <motion.div 
                        className="text-center mb-4"
                        whileHover={{ scale: 1.05 }}
                      >
                        <h3 style={{ 
                          color: getPlanColor(plan),
                          fontWeight: '700',
                          marginBottom: '5px',
                          fontSize: '2rem'
                        }}>
                          ₹{plansData[plan]?.mrp || 'N/A'}
                        </h3>
                        <small style={{ 
                          color: '#7f8c8d',
                          fontSize: '0.85rem'
                        }}>
                          Early Renewal: ₹{plansData[plan]?.fixRate || 'N/A'}
                        </small>
                      </motion.div>
                      
                      {/* Student Limit */}
                      <motion.div 
                        className="mb-4 text-center"
                        whileHover={{ scale: 1.02 }}
                      >
                        <h5 style={{ 
                                                   color: '#143625',
                          fontWeight: '600',
                          marginBottom: '10px'
                        }}>
                          Student Limit
                        </h5>
                        <p style={{ 
                          color: '#7f8c8d',
                          marginBottom: 0,
                          fontSize: '0.95rem'
                        }}>
                          {defaultPlanFeatures[plan]?.studentLimit || 'N/A'}
                        </p>
                      </motion.div>

                      {/* Features List */}
                      <div>
                        <h5 className="text-center" style={{ 
                          color: '#143625',
                          fontWeight: '600',
                          marginBottom: '15px'
                        }}>
                          Features
                        </h5>
                        <ul style={{ 
                          listStyle: 'none',
                          padding: 0,
                          margin: 0
                        }}>
                          {allFeatures.map((feature, index) => {
                            const isIncluded = defaultPlanFeatures[plan]?.features?.includes(feature) || false;
                            const isLocked = defaultPlanFeatures[plan]?.lockedModules[feature] === 'locked';
                            return (
                              <motion.li 
                                key={index} 
                                style={{ 
                                  padding: '8px 0',
                                  display: 'flex',
                                  alignItems: 'center',
                                  borderBottom: '1px solid #f1f1f1'
                                }}
                                whileHover={{ 
                                  backgroundColor: 'rgba(0,0,0,0.02)',
                                  paddingLeft: '5px'
                                }}
                              >
                                <motion.span 
                                  style={{ 
                                    marginRight: '10px',
                                    color: isIncluded ? (isLocked ? '#f39c12' : '#2ecc71') : '#e74c3c',
                                    fontSize: '1.1rem'
                                  }}
                                  animate={isIncluded ? { 
                                    scale: [1, 1.2, 1],
                                    rotate: [0, 10, -10, 0]
                                  } : {}}
                                  transition={{ duration: 0.5 }}
                                >
                                  {isIncluded ? (isLocked ? '🔒' : <FaCheck />) : <FaTimes />}
                                </motion.span>
                                <span style={{
                                  color: isIncluded ? (isLocked ? '#f39c12' : '#143625') : '#95a5a6',
                                  fontWeight: isIncluded ? '500' : '400',
                                  textDecoration: isIncluded ? 'none' : 'line-through',
                                  fontSize: '0.9rem'
                                }}>
                                  {feature} {isLocked ? '(Locked)' : ''}
                                </span>
                              </motion.li>
                            );
                          })}
                        </ul>
                      </div>

                      {/* Pay to Activate Button */}
                      <div className="text-center mt-4">
                        <button 
                          onClick={() => {
                            handlePackageSelection(plan);
                            handlePayment(plan);
                          }}
                          style={{
                            backgroundColor: getPlanColor(plan),
                            color: 'white',
                            padding: '10px',
                            borderRadius: '8px',
                            border: 'none',
                            width: '100%',
                            fontSize: '1rem',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            ':hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: `0 4px 8px ${getPlanColor(plan, true)}40`
                            }
                          }}
                          disabled={loading}
                        >
                          <FaRupeeSign />
                          Pay ₹{plansData[plan]?.mrp} to Activate
                        </button>
                      </div>

                      {/* Package details */}
                      {selectedPackage === plan && (
                        <div className="mt-3" style={{ fontSize: '0.8rem', color: '#7f8c8d' }}>
                          <p>
                            <strong>Selected Package:</strong> {plan}
                          </p>
                          <p>
                            <strong>Locked Modules:</strong> {Object.keys(lockedModules)
                              .filter(module => lockedModules[module] === 'locked')
                              .join(', ') || 'None'}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
}

export default Plansforuser;
